export default "__VITE_ASSET__9h$FQUKk__"